import { useEffect, useState } from 'react';
import { useExitIntent } from 'use-exit-intent';

import ActionModal from '@/components/ActionModal/ActionModal';
import useScrollExitIntent from '@/hooks/useScrollExitIntent';
import type { ExitIntentCF } from '@/types';

interface Props {
  config: ExitIntentCF;
}

export default function ExitIntent({ config }: Props) {
  const { actionModal, idleSeconds, cookieLength } = config.fields;
  const { isUnsubscribed, registerHandler, unsubscribe } = useExitIntent({
    cookie: {
      daysToExpire: cookieLength || 30,
      key: 'exit-intent',
    },
    desktop: {
      mouseLeaveDelayInSeconds: 1,
      triggerOnIdle: false,
    },
    mobile: {
      triggerOnIdle: !!(idleSeconds && idleSeconds > 0),
      delayInSecondsToTrigger: idleSeconds,
    },
  });
  const { registerHandler: registerScrollhandler } = useScrollExitIntent({
    scrollThreshold: 25,
  });
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
    unsubscribe();
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: Automated migration to Biome
  useEffect(() => {
    registerHandler({
      id: 'idle-and-mouse-exit-intent',
      handler: () => {
        setIsOpen(true);
      },
    });

    const { cleanup } = registerScrollhandler({
      id: 'scroll-exit-intent',
      handler: () => {
        setIsOpen(true);
      },
      context: ['onMobile'],
    });

    return () => {
      cleanup();
    };
  }, []);

  if (!actionModal || isUnsubscribed) return null;
  return (
    <ActionModal
      open={isOpen}
      onClose={handleClose}
      modalContent={actionModal}
    />
  );
}
